export { default as PromotionalBox } from './PromotionalBox';
